import { Order } from '~/@types/table/order';
import { apiClient } from '~/api/client';
import { CompanyAndAgent } from '~/components/connections/types';

type IndexParams = {
  license: string;
  page: number;
  period: Period;
  sort_field: string;
  order: Order;
};

/** Axios body from `render json: { data: result.data }` */
type IndexResponse = {
  data: {
    officers: CompanyAndAgent[];
    officers_count: number;
    officers_volume: number;
    officers_units: number;
  };
};

export const index = async (allParams: IndexParams) => {
  const { license, sort_field, order, ...params } = allParams;
  return apiClient.get<IndexResponse>(
    `/companies/${license}/tpo_loan_officers?sort[field]=${sort_field}&sort[order]=${order}`,
    { params }
  );
};
